// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.end-training-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: min(70vh, 48rem);
  overflow-y: auto;
  padding: 0.25rem 0.75rem 0.75rem;
  color: var(--text-color);
}

.end-training-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 1.25rem 1rem;
  border-radius: 0.75rem;
  background: linear-gradient(135deg, var(--extra-light-blue-background-color), white);
  text-align: center;
}

.end-training-eyebrow {
  color: var(--info-color);
  font-size: var(--font-size-s);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.end-training-hero h2,
.end-training-section h3,
.end-training-stats-heading h4 {
  margin: 0;
}

.end-training-hero h2 {
  font-size: var(--font-size-xl);
}

.end-training-rating {
  color: #f5b301;
  font-size: 2.75rem;
  line-height: 1.1;
  letter-spacing: 0.12em;
}

.end-training-rating-label {
  color: var(--text-color-inactive);
  font-size: var(--font-size-s);
}

.end-training-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.end-training-section h3 {
  font-size: var(--font-size-l);
}

.end-training-stats-list {
  display: grid;
  gap: 0.6rem;
}

.end-training-stats-card,
.end-training-errors {
  border: 1px solid var(--extra-light-grey);
  border-radius: 0.5rem;
  background: var(--dialog-background-color);
}

.end-training-stats-card {
  padding: 0.75rem;
}

.end-training-stats-heading,
.end-training-violations,
.end-training-sequences {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.end-training-stats-heading h4 {
  overflow-wrap: anywhere;
}

.end-training-stats-heading a {
  color: var(--info-color);
  cursor: pointer;
  font-size: var(--font-size-s);
  text-decoration: underline;
  white-space: nowrap;
}

.end-training-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin: 0.75rem 0;
}

.end-training-stat-grid > div {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.end-training-stat-grid span,
.end-training-rating-label {
  color: var(--text-color-inactive);
}

.end-training-stat-grid strong {
  overflow-wrap: anywhere;
}

.end-training-violations {
  padding-top: 0.5rem;
  border-top: 1px solid var(--extra-light-grey);
  font-size: var(--font-size-s);
}

.end-training-violations strong {
  color: var(--success-color);
  font-size: var(--font-size-m);
}

.end-training-violations strong.has-violations {
  color: var(--error-color);
}

.end-training-sequences {
  align-items: flex-start;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: var(--extra-light-blue-background-color);
}

.end-training-sequences strong {
  display: inline-flex;
  min-width: 1.5rem;
  height: 1.5rem;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  border-radius: 50%;
  background: var(--info-color);
  color: var(--text-contrast-color);
}

.end-training-sequences > span:last-child {
  text-align: right;
  overflow-wrap: anywhere;
}

.end-training-errors {
  max-height: 12rem;
  overflow-y: auto;
  padding: 0.75rem;
}

.end-training-errors > b span {
  color: var(--text-color-inactive);
}

.end-training-errors ul {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
}

.end-training-errors li {
  padding: 0.45rem 0.25rem;
  border-bottom: 1px solid var(--extra-light-grey);
}

.end-training-errors li:last-child {
  border-bottom: 0;
}

.end-training-errors summary {
  cursor: pointer;
}

.end-training-errors summary:hover {
  color: var(--info-color);
}

.end-training-error-detail {
  padding: 0.5rem 0 0.25rem;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.end-training-empty {
  margin: 0;
  color: var(--text-color-inactive);
  font-style: italic;
}

.end-training-prompt {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: var(--extra-light-blue-background-color);
  color: var(--info-color);
  font-size: var(--font-size-m);
}

.end-training-prompt svg {
  flex: 0 0 auto;
  font-size: 1.5rem;
}

.end-training-speed-chart {
  border: 1px solid var(--extra-light-grey);
  border-radius: 0.5rem;
  padding: 0.75rem;
  background: var(--dialog-background-color);
}

.end-training-chart-details {
  margin-top: 0.75rem;
}

.end-training-chart-details summary {
  cursor: pointer;
  color: var(--info-color);
}

.end-training-chart-details[open] summary {
  margin-bottom: 0.5rem;
}

.end-training-chart-scroll {
  overflow-x: auto;
}

.end-training-chart-scroll svg {
  display: block;
  width: 100%;
  min-width: 650px;
  color: var(--text-color);
}

.end-training-chart-scroll text {
  fill: currentColor;
  font-size: 12px;
}

.end-training-chart-grid {
  stroke: var(--extra-light-grey);
}

.end-training-chart-threshold {
  color: var(--error-color);
}

.end-training-chart-episode {
  fill: var(--error-color);
  opacity: 0.2;
  cursor: help;
}

.end-training-chart-episode:hover {
  opacity: 0.35;
}

.end-training-chart-tooltip rect {
  fill: var(--dark-grey);
  stroke: var(--border-color);
}

.end-training-chart-tooltip text {
  fill: var(--text-contrast-color);
  font-size: 13px;
}

.end-training-chart-episode-legend {
  margin: 0.5rem 0 0;
  color: var(--text-color-inactive);
  font-size: var(--font-size-s);
}

.end-training-chart-stage-marker {
  cursor: help;
}

.end-training-chart-stage {
  stroke: var(--text-color-inactive);
  stroke-dasharray: 4 4;
}

.end-training-chart-stage-dot {
  fill: var(--info-color);
  stroke: var(--dialog-background-color);
  stroke-width: 2px;
}

@media (max-width: 600px) {
  .end-training-content {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }

  .end-training-stat-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/training-dialog/end-training-dialog/EndTrainingDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,yCAAyC;EACzC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,oDAAoD;EACpD,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".end-training-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-height: min(70vh, 48rem);\n  overflow-y: auto;\n  padding: 0.25rem 0.75rem 0.75rem;\n  color: var(--text-color);\n}\n\n.end-training-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 1.25rem 1rem;\n  border-radius: 0.75rem;\n  background: linear-gradient(135deg, var(--extra-light-blue-background-color), white);\n  text-align: center;\n}\n\n.end-training-eyebrow {\n  color: var(--info-color);\n  font-size: var(--font-size-s);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.end-training-hero h2,\n.end-training-section h3,\n.end-training-stats-heading h4 {\n  margin: 0;\n}\n\n.end-training-hero h2 {\n  font-size: var(--font-size-xl);\n}\n\n.end-training-rating {\n  color: #f5b301;\n  font-size: 2.75rem;\n  line-height: 1.1;\n  letter-spacing: 0.12em;\n}\n\n.end-training-rating-label {\n  color: var(--text-color-inactive);\n  font-size: var(--font-size-s);\n}\n\n.end-training-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.end-training-section h3 {\n  font-size: var(--font-size-l);\n}\n\n.end-training-stats-list {\n  display: grid;\n  gap: 0.6rem;\n}\n\n.end-training-stats-card,\n.end-training-errors {\n  border: 1px solid var(--extra-light-grey);\n  border-radius: 0.5rem;\n  background: var(--dialog-background-color);\n}\n\n.end-training-stats-card {\n  padding: 0.75rem;\n}\n\n.end-training-stats-heading,\n.end-training-violations,\n.end-training-sequences {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.end-training-stats-heading h4 {\n  overflow-wrap: anywhere;\n}\n\n.end-training-stats-heading a {\n  color: var(--info-color);\n  cursor: pointer;\n  font-size: var(--font-size-s);\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.end-training-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.5rem;\n  margin: 0.75rem 0;\n}\n\n.end-training-stat-grid > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.end-training-stat-grid span,\n.end-training-rating-label {\n  color: var(--text-color-inactive);\n}\n\n.end-training-stat-grid strong {\n  overflow-wrap: anywhere;\n}\n\n.end-training-violations {\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--extra-light-grey);\n  font-size: var(--font-size-s);\n}\n\n.end-training-violations strong {\n  color: var(--success-color);\n  font-size: var(--font-size-m);\n}\n\n.end-training-violations strong.has-violations {\n  color: var(--error-color);\n}\n\n.end-training-sequences {\n  align-items: flex-start;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  background: var(--extra-light-blue-background-color);\n}\n\n.end-training-sequences strong {\n  display: inline-flex;\n  min-width: 1.5rem;\n  height: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0.35rem;\n  border-radius: 50%;\n  background: var(--info-color);\n  color: var(--text-contrast-color);\n}\n\n.end-training-sequences > span:last-child {\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n\n.end-training-errors {\n  max-height: 12rem;\n  overflow-y: auto;\n  padding: 0.75rem;\n}\n\n.end-training-errors > b span {\n  color: var(--text-color-inactive);\n}\n\n.end-training-errors ul {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.5rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.end-training-errors li {\n  padding: 0.45rem 0.25rem;\n  border-bottom: 1px solid var(--extra-light-grey);\n}\n\n.end-training-errors li:last-child {\n  border-bottom: 0;\n}\n\n.end-training-errors summary {\n  cursor: pointer;\n}\n\n.end-training-errors summary:hover {\n  color: var(--info-color);\n}\n\n.end-training-error-detail {\n  padding: 0.5rem 0 0.25rem;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.end-training-empty {\n  margin: 0;\n  color: var(--text-color-inactive);\n  font-style: italic;\n}\n\n.end-training-prompt {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  background: var(--extra-light-blue-background-color);\n  color: var(--info-color);\n  font-size: var(--font-size-m);\n}\n\n.end-training-prompt svg {\n  flex: 0 0 auto;\n  font-size: 1.5rem;\n}\n\n.end-training-speed-chart {\n  border: 1px solid var(--extra-light-grey);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  background: var(--dialog-background-color);\n}\n\n.end-training-chart-details {\n  margin-top: 0.75rem;\n}\n\n.end-training-chart-details summary {\n  cursor: pointer;\n  color: var(--info-color);\n}\n\n.end-training-chart-details[open] summary {\n  margin-bottom: 0.5rem;\n}\n\n.end-training-chart-scroll {\n  overflow-x: auto;\n}\n\n.end-training-chart-scroll svg {\n  display: block;\n  width: 100%;\n  min-width: 650px;\n  color: var(--text-color);\n}\n\n.end-training-chart-scroll text {\n  fill: currentColor;\n  font-size: 12px;\n}\n\n.end-training-chart-grid {\n  stroke: var(--extra-light-grey);\n}\n\n.end-training-chart-threshold {\n  color: var(--error-color);\n}\n\n.end-training-chart-episode {\n  fill: var(--error-color);\n  opacity: 0.2;\n  cursor: help;\n}\n\n.end-training-chart-episode:hover {\n  opacity: 0.35;\n}\n\n.end-training-chart-tooltip rect {\n  fill: var(--dark-grey);\n  stroke: var(--border-color);\n}\n\n.end-training-chart-tooltip text {\n  fill: var(--text-contrast-color);\n  font-size: 13px;\n}\n\n.end-training-chart-episode-legend {\n  margin: 0.5rem 0 0;\n  color: var(--text-color-inactive);\n  font-size: var(--font-size-s);\n}\n\n.end-training-chart-stage-marker {\n  cursor: help;\n}\n\n.end-training-chart-stage {\n  stroke: var(--text-color-inactive);\n  stroke-dasharray: 4 4;\n}\n\n.end-training-chart-stage-dot {\n  fill: var(--info-color);\n  stroke: var(--dialog-background-color);\n  stroke-width: 2px;\n}\n\n@media (max-width: 600px) {\n  .end-training-content {\n    padding-right: 0.25rem;\n    padding-left: 0.25rem;\n  }\n\n  .end-training-stat-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
